/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Fix for product list items inside offcanvas mobile menu
document.querySelectorAll('#offcanvas-menu-upsell-collection .btn-atc').forEach(($btn) => {
    $btn.addEventListener('click', () => {
        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-mobile-menu')
        offcanvas.hide()
    })
})

/*
    Navbar menu items open on hover (not click)
*/
document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
    $item.addEventListener('mouseenter', () => {
        document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        })

        $item.classList.add('show')
        $item.setAttribute('aria-expaned', 'true')
        $item.nextElementSibling.classList.add('show')
        $item.nextElementSibling.setAttribute('data-bs-popper', 'none')
    })
    $item.addEventListener('mouseleave', () => {
        if (!$item.nextElementSibling.matches(':hover')) {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        }
    })

    $item.addEventListener('click', (e) => {
        window.location.href = $item.getAttribute('href')
    })
})
document.querySelector('#main').addEventListener('mouseenter', () => {
    document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
        $item.classList.remove('show')
        $item.setAttribute('aria-expaned', 'false')
        $item.nextElementSibling.classList.remove('show')
    })
})

// Swap product card image + price when the size/variant select changes
// (collection grid + offcanvas mobile menu).
window.onChangeProductListItemVariant = (event) => {
    const select = event.target
    const card = select.closest('li.product-list-item, [role="list-item"]')
    if (!card) return

    const selectedOption = select.options[select.selectedIndex]
    const variantImageId = selectedOption.dataset.variantImageId
    const variantImageUrl = selectedOption.dataset.variantImageUrl

    // Price swap. Per-variant final price + effective compare-at are
    // pre-computed in Liquid (see snippets/product-list-item.liquid) so the
    // sale-event discount stays in sync without duplicating the math here.
    const priceFinal = card.querySelector('.product-price-final')
    if (priceFinal && selectedOption.dataset.variantPriceFormatted) {
        priceFinal.textContent = selectedOption.dataset.variantPriceFormatted
    }
    const priceCompare = card.querySelector('.product-price-compare')
    if (priceCompare) {
        const compareFormatted = selectedOption.dataset.variantCompareAtPriceFormatted
        const amountEl = priceCompare.querySelector('.product-price-compare-amount')
        if (compareFormatted) {
            if (amountEl) amountEl.textContent = compareFormatted
            priceCompare.classList.remove('d-none')
        } else {
            priceCompare.classList.add('d-none')
        }
    }

    // Keep the Buy with Prime tag in sync with the selected variant. The card tag
    // is the basic (non-variant-helper) element, so per Amazon's guidance for
    // collection-card variant selectors we update its product reference in place on
    // change: a non-Prime-eligible size (e.g. XL) then renders nothing, instead of
    // the tag staying stuck on the default (Original) variant's Prime estimate.
    // Update the attribute in place - do NOT recreate the element: recreating makes
    // the Amazon runtime re-render every tag on the page, flickering all the cards.
    // Two copies on the card (checkmark + date, see product-sale-price-card.liquid) -
    // keep both in sync with the selected variant.
    if (select.value) {
        card.querySelectorAll('amazon-delivery-message').forEach((bwpTag) => {
            bwpTag.setAttribute('product-external-id', `gid://shopify/ProductVariant/${select.value}`)
        })
    }

    const carousel = card.querySelector('.product-carousel')
    if (carousel) {
        const slides = Array.from(carousel.querySelectorAll('.carousel-item'))
        let targetIndex = -1
        if (variantImageId) {
            targetIndex = slides.findIndex((s) => s.dataset.imageId === variantImageId)
        }
        // If the matched slide is tied to a disabled variant, or there was no
        // match at all (e.g. the picked variant has no variant.image set, so
        // we'd otherwise default to slide 0 — which can itself be an XL flatlay
        // promoted into product.images), fall back to the first reachable slide.
        if (targetIndex < 0 || slides[targetIndex].dataset.variantUnavailable === 'true') {
            targetIndex = slides.findIndex((s) => s.dataset.variantUnavailable !== 'true')
        }
        if (targetIndex >= 0) {
            bootstrap.Carousel.getOrCreateInstance(carousel).to(targetIndex)
        }
    } else {
        const img = card.querySelector('img.product-img')
        if (img) {
            if (!img.dataset.defaultSrc) img.dataset.defaultSrc = img.src
            img.src = variantImageUrl || img.dataset.defaultSrc
        }
    }

    // Swap ATC ↔ notify-me when the user picks an OOS (disabled) option.
    const variantUnavailable = !!selectedOption.disabled
    const atcBtn = card.querySelector('.product-list-item__atc-btn')
    const notifyWrapper = card.querySelector('.product-list-item__notify-wrapper')
    if (atcBtn) atcBtn.classList.toggle('d-none', variantUnavailable)
    if (notifyWrapper) notifyWrapper.classList.toggle('d-none', !variantUnavailable)
}

// Block the product card carousel from landing on an image whose only
// associated variants are disabled (OOS / XL-gated) — mirrors the dropdown,
// which doesn't let the user pick those variants either. Reachability is read
// from the <select> the card already renders, so no Liquid changes are needed.
// Registered before the sync-on-load block below so the `variant-unavailable`
// marking is in place by the time any variant-change handler runs.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('li.product-list-item, [role="list-item"]').forEach((card) => {
        const carousel = card.querySelector('.product-carousel')
        if (!carousel) return
        const select = card.querySelector('select[onchange*="onChangeProductListItemVariant"]')
        if (select) {
            const reachable = new Map()
            Array.from(select.options).forEach((opt) => {
                const id = opt.dataset.variantImageId
                if (!id) return
                if (!reachable.has(id)) reachable.set(id, false)
                if (!opt.disabled) reachable.set(id, true)
            })
            const slides = Array.from(carousel.querySelectorAll('.carousel-item'))
            slides.forEach((slide) => {
                const id = slide.dataset.imageId
                if (id && reachable.has(id) && reachable.get(id) === false) {
                    slide.dataset.variantUnavailable = 'true'
                }
            })
            // If the server-rendered active slide is unreachable (the XL flatlay
            // got promoted to product.images[0] when Halie attached it as the XL
            // variant's cover image), advance to the first reachable slide so the
            // card image matches the dropdown's auto-selected in-stock variant.
            const activeIndex = slides.findIndex((s) => s.classList.contains('active'))
            if (activeIndex >= 0 && slides[activeIndex].dataset.variantUnavailable === 'true') {
                const firstReachable = slides.findIndex((s) => s.dataset.variantUnavailable !== 'true')
                if (firstReachable >= 0) {
                    bootstrap.Carousel.getOrCreateInstance(carousel).to(firstReachable)
                }
            }
        }
        // Detach the Bootstrap data-API binding so we can hop over blocked slides
        // instead of letting the default prev/next handler land on one.
        carousel.querySelectorAll('.carousel-control[data-bs-slide]').forEach((btn) => {
            const direction = btn.dataset.bsSlide
            btn.removeAttribute('data-bs-slide')
            btn.removeAttribute('data-bs-target')
            btn.addEventListener('click', (e) => {
                e.preventDefault()
                e.stopPropagation()
                const slides = Array.from(carousel.querySelectorAll('.carousel-item'))
                if (slides.length <= 1) return
                const activeIndex = slides.findIndex((s) => s.classList.contains('active'))
                const step = direction === 'next' ? 1 : -1
                let nextIndex = activeIndex
                for (let i = 0; i < slides.length; i++) {
                    nextIndex = (nextIndex + step + slides.length) % slides.length
                    if (nextIndex === activeIndex) return
                    if (slides[nextIndex].dataset.variantUnavailable !== 'true') {
                        bootstrap.Carousel.getOrCreateInstance(carousel).to(nextIndex)
                        return
                    }
                }
            })
        })
    })
})

// Sync product card image + price on load when the initially-selected variant
// isn't the first option in the dropdown — e.g., the first variant is OOS so
// the browser auto-skipped to the next available one. The card was already
// rendered server-side from product.featured_image / product.price (which
// reflect the first variant), so without this it shows the OOS variant's
// image and price even though the dropdown shows the in-stock one.
document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('select[onchange*="onChangeProductListItemVariant"]')
        .forEach((select) => {
            if (select.selectedIndex > 0) {
                select.dispatchEvent(new Event('change'))
            }
        })
})

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (inputValue > 1) {
        input.setAttribute('value', inputValue - 1)
        input.dispatchEvent(new Event('change'))
    }
}
window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    input.setAttribute('value', inputValue + 1)
    input.dispatchEvent(new Event('change'))
}
// Offcanvas wishlist - Open it if URL contains '#wishlist'
if (window.location.hash.includes('#wishlist')) {
    const offcanvasWishlist = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-wishlist')
    offcanvasWishlist.show()
}

// Gorgias chat - widget adjustments on various occasions
document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
        const el = document.querySelector('#gorgias-chat-container')
        if (el) {
            el.style.display = 'none'
        }
    })
})

document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('hide.bs.offcanvas', () => {
        const el = document.querySelector('#gorgias-chat-container')
        if (el) {
            el.style.display = 'block'
        }
    })
})


// RAVN CHANGE - 03/02/2026
// The "RAVN Desk/Mobile - Back In Stock Custom" sign-up units in Attentive
// are gated by a URL display rule ("URL contains 'attentive-back-in-stock'"),
// not by a JS-side `trigger()` / `show()` call. The SDK watches History API
// changes and re-evaluates its display rules — so opening the modal is a
// matter of putting that string in the URL.
const ATTENTIVE_BACK_IN_STOCK_URL_TOKEN = 'attentive-back-in-stock'

const triggerAttentive = () => {
  const url = new URL(window.location.href)
  if (url.searchParams.has(ATTENTIVE_BACK_IN_STOCK_URL_TOKEN)) return
  url.searchParams.set(ATTENTIVE_BACK_IN_STOCK_URL_TOKEN, '1')
  // Full navigation: Attentive's SDK only checks display rules on initial page
  // load — silent History API updates are invisible to it. Costs one reload.
  window.location.replace(url.toString())
}

/* ------------------------------
   Attentive - Collection Page
-------------------------------- */
// Collection cards live at /collections/... so calling triggerAttentive() here
// would leave Attentive with no product context (the URL would just be the
// collection page + token). Redirect to the product's PDP with the token —
// and the selected variant id if the card's size <select> has one — so the
// Attentive sign-up unit can bind the subscription to a real product/variant.
document
  .querySelectorAll('.btn-notify-me-attentive-collection')
  .forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.product-list-item__notify-wrapper')
      const productUrl = wrapper && wrapper.dataset.productUrl
      if (!productUrl) {
        triggerAttentive()
        return
      }
      const url = new URL(productUrl, window.location.origin)
      const card = btn.closest('li.product-list-item, [role="list-item"]')
      const select = card && card.querySelector('select[name="id"]')
      if (select && select.value) {
        url.searchParams.set('variant', select.value)
      }
      url.searchParams.set(ATTENTIVE_BACK_IN_STOCK_URL_TOKEN, '1')
      window.location.assign(url.toString())
    })
  })

/* ------------------------------
   Attentive - Product Page
-------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.btn-notify-me-attentive').forEach(btn => {
    btn.addEventListener('click', () => {
      triggerAttentive()
    })
  })
})